import React, {useCallback} from "react";
import classNames from "classnames";
import {useSelector, useDispatch} from "react-redux";
import ReactGA from 'react-ga';

import {moveToMenu} from "../module/ScrollModule";
import {textMap, imageMap} from "../common/Localization";

import './Header.scss';

const Header = () => {
	const dispatch = useDispatch();
	const showHeaderLine = useSelector(state => state.ScrollModule.showHeaderLine);

	const onClickMenu = useCallback((id) => {
		dispatch(moveToMenu(id));
		if(id === "topIntro") {
			ReactGA.event({
				category:"PARTNER",
				action:"메뉴이동",
				label:"헤더-로고"
			});
		} else if(id === "whyMinimap1") {
			ReactGA.event({
				category:"PARTNER",
				action:"메뉴이동",
				label:"헤더-왜미니맵인가요?"
			});
		} else if(id === "price") {
			ReactGA.event({
				category:"PARTNER",
				action:"메뉴이동",
				label:"헤더-가격정보"
			});
		} else if(id === "faq") {
			ReactGA.event({
				category:"PARTNER",
				action:"메뉴이동",
				label:"헤더-FAQ"
			});
		}
	}, [dispatch]);

	const sendGa = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"미니맵-문의",
			label:"헤더-문의하기"
		});
	}, []);
	const sendGa2 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-광고",
			label:"헤더-광고시작하기"
		});
	}, []);

	return (
		<div id="header" className={classNames("bc_ff", showHeaderLine ? "lc_eb" : "lc_transparent")}>
			<div className="header_wrap">
				<img className="logo" src={process.env.PUBLIC_URL + "/img/" + imageMap.full_logo} alt="" onClick={() => onClickMenu("topIntro")}/>
				<img className="small_logo" src={process.env.PUBLIC_URL + "/icon/logo.png"} alt="" onClick={() => onClickMenu("topIntro")}/>
				<span className={classNames("tab_menu", "t_15", "c_4a")}>
					<span className="tab_button" onClick={() => onClickMenu("whyMinimap1")}>{textMap.header_why}</span>
					<span className="tab_button" onClick={() => onClickMenu("price")}>{textMap.header_price}</span>
					<span className="tab_button" onClick={() => onClickMenu("faq")}>{textMap.header_faq}</span>
					<span className="tab_button"><a href="https://minimap.net/auth/help" target="_blank" rel="noopener noreferrer" onClick={sendGa}>{textMap.header_ask}</a></span>
					<a href="https://minimap2.imweb.me/#doz_body" target="_blank" rel="noopener noreferrer" onClick={sendGa2}>
						<span className={classNames("start_button", "cbc_blue", "sc_blue", "c_ff", "t_13")}>{textMap.header_start_button}</span>
					</a>
				</span>
			</div>
		</div>
	);
};

export default Header;
